import React from "react";
import moment from "moment";

import { ContractsTableActions } from "./ContractsTableActions";

export const getContractsTableColumns = ({
  entityId = null,
  deleteContract,
  invalidateData,
}) => {
  return [
    {
      header: "Contract ID",
      id: "Contract ID",
      accessorKey: "id",
    },
    {
      header: "External Contract #",
      id: "External Contract #",
      accessorKey: "external_contract_num",
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    {
      header: "Description",
      id: "Description",
      accessorKey: "description",
      enableSorting: false,
    },
    {
      header: "Department",
      id: "Department",
      accessorKey: "department_name",
    },
    {
      header: "Start Date",
      id: "Start Date",
      accessorKey: "start_date",
      cell: ({ row }) => {
        const value = row.original?.start_date;
        if (value !== undefined && value !== null) {
          return moment(value).format("YYYY-MM-DD");
        }
        return null;
      },
    },
    {
      header: "End Date",
      id: "End Date",
      accessorKey: "end_date",
      cell: ({ row }) => {
        const value = row.original?.end_date;
        if (value !== undefined && value !== null) {
          return moment(value).format("YYYY-MM-DD");
        }
        return null;
      },
    },
    {
      header: "Number of Licenses",
      id: "Number of Licenses",
      accessorKey: "num_licenses",
    },
    {
      header: "Parent Contract Name",
      id: "Parent Contract Name",
      accessorKey: "parent_contract_name",
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => {
        return (
          <ContractsTableActions
            original={row.original}
            entityId={entityId}
            deleteContract={deleteContract}
            invalidateData={invalidateData}
          />
        );
      },
    },
  ];
};

export const getContractsTableFilters = ({ contractOptions }) => {
  return [
    {
      key: "parent_contract_id",
      title: "Parent Contract",
      type: "select",
      data: contractOptions,
    },
    {
      key: "start_date",
      title: "Start Date",
      type: "dateRange",
    },
    {
      key: "end_date",
      title: "End Date",
      type: "dateRange",
    },
  ];
};
